import submit from "submit-form";
import { truncateText } from "../../utils/string-helpers";
import Dropdown from "../dropdown";
import DropdownFocus from "../dropdown-focus";

type Option = {
  text?: string;
  label?: string;
  value: string;
};

interface SelectProps {
  name: string;
  options: Option[];
  onChange: (value: string) => void;
  title?: string;
  value: string;
  disabled: boolean;
  withFocus?: boolean;
  withTruncate?: boolean;
  overlay?: boolean;
  openUpward?: boolean;
  alignRight?: boolean;
  form?: string;
  /** Shown in the closed control when value is not listed in options */
  displayLabel?: string;
}

function Select({
  name,
  options,
  onChange,
  title,
  value,
  disabled,
  withFocus = false,
  withTruncate = false,
  overlay = false,
  openUpward = false,
  alignRight = false,
  form,
  displayLabel,
}: SelectProps) {
  const summaryText =
    displayLabel ||
    (options?.length > 0 &&
      (options.find((item: Option) => value === item.value)?.text ||
        options.find((item: Option) => value === item.value)?.label)) ||
    value ||
    "";

  const commonProps = {
    options,
    summaryText: withTruncate ? truncateText(summaryText, 30) : summaryText,
    onSelectFn: (newVal: string) => {
      if (onChange) return onChange(newVal);

      submit(`/actions/refresh`, {
        method: "GET",
        body: { [name]: newVal },
      });
    },
    disabled,
    overlay,
    openUpward,
    alignRight,
  };

  return (
    <>
      {title && <label htmlFor={name}>{title}</label>}
      <input
        type="hidden"
        name={name}
        value={value}
        form={form}
        onChange={() => {}}
      />
      {withFocus ? (
        <DropdownFocus {...commonProps} />
      ) : (
        <Dropdown {...commonProps} overlay={overlay} />
      )}
    </>
  );
}

export default Select;
